import React from "react";
import { GraduationCapIcon } from "lucide-react";
import { brand, footer } from "../data/salesCopy";
export function Footer() {
  return <footer data-hide-sticky className="bg-ink py-8 text-white md:py-12" data-id="element-99" data-mp="3ggk7gsifd7yh">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-100" data-mp="32ovvqqc38li1">
        <p className="flex items-center justify-center gap-2 font-display text-base font-bold md:text-xl" data-id="element-101" data-mp="36pfvm1o1q37v">
          <GraduationCapIcon className="h-5 w-5 shrink-0 text-pencil md:h-6 md:w-6" aria-hidden="true" data-id="element-102" data-mp="3ufa64ckw7foy" />
          {brand.product}™
        </p>
        <p className="mx-auto mt-2 max-w-xl text-xs text-white/70 md:mt-3 md:text-base" data-id="element-103" data-mp="387clehl0xbk">{footer.tagline}</p>
        <p className="mt-4 flex flex-wrap justify-center gap-x-3 gap-y-1 text-xs text-white/80 md:mt-6 md:text-sm" data-id="element-104" data-mp="3le2iqpjwzz9n">
          <a href={`mailto:${brand.email}`} className="hover:text-pencil" data-id="element-105" data-mp="3qfjfc8vd8zkf">{brand.email}</a>
          <span aria-hidden="true" data-id="element-106" data-mp="2a19tpmiidoxa">•</span>
          <span data-id="element-107" data-mp="2eyt8cnj4c3pr">{brand.instagram}</span>
          <span aria-hidden="true" data-id="element-108" data-mp="2ezut5jpxs4ko">•</span>
          <span data-id="element-109" data-mp="3l9k1v1qqp380">{brand.web}</span>
        </p>
        <p className="mt-4 text-[11px] text-white/50 md:mt-6 md:text-xs" data-id="element-110" data-mp="3labrlvxno6qd">{footer.copyright}</p>
      </div>
    </footer>;
}